import { BUNDLE_TYPE, CURRENT_COUNTRY } from "./constants";

/**
 * Shopify `bundle_components` (synced from `bundle.components`) wins when present; else merged `products_included` / legacy.
 */
export const getBundleSubproductLines = (product) => {
	if (!product) return [];

	const fromComponents = product.bundle_components;
	if (Array.isArray(fromComponents) && fromComponents.length > 0) return fromComponents;

	const merged = product.products_included;
	if (Array.isArray(merged) && merged.length > 0) return merged;

	return product.subproducts || [];
};

/*
 * Always use this item when checking if its a bundle unless you only need to check for its "type" only
 * */
const isBundleWithSubProducts = (product) => {
	if (!product) return false;

	if ("type" in product && product.type === BUNDLE_TYPE) {
		return getBundleSubproductLines(product).length > 0;
	}

	return false;
};

export const isAddOn = (product) => {
	return (
		product?.type?.toLowerCase() === "add-on" ||
		product?.productType?.toLowerCase() === "add-on" ||
		product?._type?.toLowerCase() === "add-on" ||
		product?.weightInGrams < 1000 //? 1 or 1000?
	);
};

export const bundleSubProductsTotalQTY = (bundle) => {
	let qty = 0;
	const subproducts = getBundleSubproductLines(bundle);

	for (let i = 0; i < subproducts.length; i++) {
		qty += subproducts[i].__quantity;
	}

	return qty;
};

// TODO: add a permanent solution
const bundleConfig = {
	de: [11743779717388, 11743844794636],
	ch: [10708516241754, 10708742340954],
	nl: [10602200301905, 10602193584465],
}[CURRENT_COUNTRY];

// TODO: add a permanent solution
export const disallowedBundleCombination = (lines, currBundleID, linesToCreate = {}) => {
	let count = 0;
	const currId = +String(currBundleID).split("__")[0];
	const allItems = [...lines, ...Object.values(linesToCreate)];

	for (const line of allItems) {
		if (bundleConfig.includes(+line?.productShopifyId) && bundleConfig.includes(currId)) {
			count += 2;
		}
	}

	return count >= 2;
};

/*
 * this is a temporary solution for swaping bundles from old approach to new approach
 *
 * */
export const swapPrevBundleToNewBundle = async (items, callback, isSubscription = false) => {
	const _items = Object.values(items);

	if (!_items.length) return;

	const bundles = {};

	if (localStorage.getItem("_swaped")) return;

	for (const item of _items) {
		if (!isBundleWithSubProducts(item)) continue;

		if (isSubscription) {
			bundles[item.id] = {
				product_variant_id: item.raw.variantId,
				product_id: "gid://shopify/Product/" + item.id,
				quantity: item.quantity,
				custom_attributes: [{ key: "weightInGrams", value: String(item.weightInGrams) }],
				type: "subscription",
				products_included: getBundleSubproductLines(item),
			};
		} else {
			bundles[item.id] = {
				id: item.variant.id,
				quantity: item.quantity,
				attributes: item.attributes,
				products_included: item.subproducts?.length ? item.subproducts : getBundleSubproductLines(item),
			};
		}
	}

	try {
		await callback(bundles);

		localStorage.setItem("_swaped", true);
		return true;
	} catch (err) {
		console.error(err);
		return false;
	}
};

export default isBundleWithSubProducts;